import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {SoftSkill} from '../../shared/soft-skill';
import jQuery from 'jquery';

@Component({
    selector: 'occupational-profile-soft-skill',
    templateUrl: './occupational-profile-soft-skill.component.html',
    styleUrls: ['./occupational-profile-soft-skill.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OccupationalProfileSoftSkillComponent implements OnInit {

    @Input()
    public softSkills?: Array<SoftSkill>;
    @Input()
    public title!: string;

    showAllSoftSkills = false;
    restSoftSkills: Array<SoftSkill> = new Array<SoftSkill>();


    toggleAllSoftSkills(event: any): void {
        (jQuery||$)(event.target).closest('.c-skills__show-extra').siblings('.extraSoftSkills').slideToggle(150);
        this.showAllSoftSkills = !this.showAllSoftSkills;
    }

    ngOnInit(): void {
		if (this.softSkills) {
			this.restSoftSkills = this.softSkills.splice(5, this.softSkills.length);
		}
    }

    hasRestSoftSkills(): boolean {
        return this.restSoftSkills.length > 0;
    }
}
